import "../../styles/style"
import "../../badge/style"
import "../index.scss"
